import { useLocation } from 'react-router-dom';
import { Navigation } from '@shopify/polaris';
import {
  HomeIcon,
  OrderIcon,
  PackageIcon,
  ReturnIcon,
  ClockIcon,
  SettingsIcon,
  LocationIcon,
  PersonIcon,
  LockIcon,
  ProductIcon,
} from '@shopify/polaris-icons';
import persistSearch from '../utils/persistSearch';

const ITEMS = [
  { url: '/', label: 'Home', icon: HomeIcon },
  { url: '/order_shipments', label: 'Order shipments', icon: OrderIcon },
  { url: '/batches', label: 'Batches', icon: PackageIcon },
  { url: '/returns', label: 'Returns', icon: ReturnIcon },
  { url: '/history', label: 'History', icon: ClockIcon },
  { url: '/settings', label: 'Settings', icon: SettingsIcon },
  { url: '/cart_layouts', label: 'Cart layouts', icon: LocationIcon },
  { url: '/users', label: 'Users', icon: PersonIcon },
  { url: '/login_codes', label: 'Login codes', icon: LockIcon },
  { url: '/rules', label: 'Packing rules', icon: ProductIcon },
];

export default function NavMenu() {
  const location = useLocation();

  return (
    <Navigation location={location.pathname}>
      <Navigation.Section
        items={ITEMS.map((item) => ({
          ...item,
          url: persistSearch(item.url),
          selected:
            item.url === '/'
              ? location.pathname === '/'
              : location.pathname.startsWith(item.url),
        }))}
      />
      <Navigation.Section
        title="Warehouse"
        items={[
          {
            url: persistSearch('/warehouse/app', { context: 'admin' }),
            label: 'Warehouse app',
            icon: PackageIcon,
          },
        ]}
      />
    </Navigation>
  );
}

